// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ExportPayload\ApiExportPayload.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BillExportPayloadAssignment, BillExportPayloadAssignmentData, BillExportPayloadAssignmentOptions } from 'data/models/BillExportPayloadAssignment';
import { BillingSystem, BillingSystemData, BillingSystemOptions } from 'data/models/BillingSystem';
import { ExportDelivery, ExportDeliveryData, ExportDeliveryOptions } from 'data/models/ExportDelivery';
import { ExportPayloadStatus, ExportTargetType } from 'server/enums/ExportPayload';

// ExportPayloadData is the class that ExportPayload serializes to/from
export interface ExportPayloadData {
    Id : number;
	
    BillingSystem : BillingSystemData | null;
    BillingSystemId : number;
    Bills : BillExportPayloadAssignmentData[] | null;
    Deliveries : ExportDeliveryData[] | null;
	
    CreatedDate : /* ISO8601 */ string;
    ErrorMessage : string | null;
    Guid : /* GUID */ string;
    RawExport : string | null;
    Status : ExportPayloadStatus;
    TargetType : ExportTargetType;
}

// ExportPayloadOptions is the class which may be passed to the ExportPayload constructor to define optional initial data values
export interface ExportPayloadOptions {
    Id : number;
	
    BillingSystem? : BillingSystemOptions | null;
    BillingSystemId? : number;
    Bills? : BillExportPayloadAssignmentOptions[] | null;
    Deliveries? : ExportDeliveryOptions[] | null;
	
    CreatedDate? : /* ISO8601 */ string;
    ErrorMessage? : string | null;
    Guid? : /* GUID */ string;
    RawExport? : string | null;
    Status? : ExportPayloadStatus;
    TargetType? : ExportTargetType;
}

export class ExportPayload {
    public Id : DataSignal<number>;
	
    public BillingSystem : DataSignal<BillingSystem | null>;
    public BillingSystemId : DataSignal<number>;
    public Bills : SDataArray<BillExportPayloadAssignment>;
    public Deliveries : SDataArray<ExportDelivery>;
	
    public CreatedDate : DataSignal<TZDate>;
    public ErrorMessage : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public RawExport : DataSignal<string | null>;
    public Status : DataSignal<ExportPayloadStatus>;
    public TargetType : DataSignal<ExportTargetType>;

    constructor();
    constructor(data : ExportPayloadOptions);
    constructor(data: ExportPayloadOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.BillingSystem = S.value<BillingSystem | null>(null);
        this.BillingSystemId = jsonableObservable(S.value<number>(data && data.BillingSystemId !== undefined ? data.BillingSystemId : 0));
        this.Bills = SArray<BillExportPayloadAssignment>([]);
        this.Deliveries = SArray<ExportDelivery>([]);
	    
        this.CreatedDate = jsonableObservable(S.value<TZDate>(data && data.CreatedDate !== undefined ? new TZDate(data.CreatedDate) : new TZDate(0), TZDate.eq));
        this.ErrorMessage = jsonableObservable(S.value<string | null>(data && data.ErrorMessage !== undefined ? data.ErrorMessage : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.RawExport = jsonableObservable(S.value<string | null>(data && data.RawExport !== undefined ? data.RawExport : null));
        this.Status = jsonableObservable(S.value<ExportPayloadStatus>(data && data.Status !== undefined ? data.Status : 0));
        this.TargetType = jsonableObservable(S.value<ExportTargetType>(data && data.TargetType !== undefined ? data.TargetType : 0));
    }

    static key(obj : ExportPayload) {
        return obj.Id();
    }
    
    static dataKey(obj : ExportPayloadOptions) {
        return obj.Id;
    }

    static update(obj : ExportPayload, data : ExportPayloadOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BillingSystemId !== undefined) obj.BillingSystemId(data.BillingSystemId);
	        
            if (data.CreatedDate !== undefined) obj.CreatedDate(new TZDate(data.CreatedDate));
            if (data.ErrorMessage !== undefined) obj.ErrorMessage(data.ErrorMessage);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.RawExport !== undefined) obj.RawExport(data.RawExport);
            if (data.Status !== undefined) obj.Status(data.Status);
            if (data.TargetType !== undefined) obj.TargetType(data.TargetType);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ExportPayload.ts